import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=5231bec1&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=5231bec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231bec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5231bec1')) {
      api.createRecord('5231bec1', component.options)
    } else {
      api.reload('5231bec1', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=5231bec1&scoped=true&", function () {
      api.rerender('5231bec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/DocBox.vue"
export default component.exports